export default __webpack_public_path__ + "static/media/29_desktop.58d97cde.jpg";